import { fromTable } from "../utils/tables";
import { startingBonuses } from "../tables";

export const getStartingBonus = ({ formatMessage }) => {
  const result = fromTable(startingBonuses);
  const values = result.getValues ? result.getValues() : {};

  return {
    name: formatMessage(result.name, values),
    description: result.description
      ? formatMessage(result.description, values)
      : undefined,
    hpModifier: result.hpModifier,
  };
};
